import React from 'react'

import clsx from 'clsx'

import classes from './Navigation.module.scss'

class NavigationMenu extends React.Component {
  renderItem = item => {
    if (item === undefined) return

    const { active } = this.props

    let isActive = false

    if (active.includes('#')) {
      const subLink = item.path.split('#').join('/#')

      isActive = subLink === active
    } else {
      isActive = item.path.concat('/') === active
    }

    const className = clsx(classes.menuItem, {
      [classes.menuItem_isActive]: isActive,
    })

    const subMenuClassname = clsx(classes.subMenu, {
      [classes.subMenu_isActive]: isActive,
    })
    return (
      <div key={item.path} className={className}>
        <a href={item.path.includes('#') ? item.path.split('#').join('/#') : item.path.concat('/')}>{item.title}</a>
        {item.submenu && <div className={subMenuClassname}>{this.renderItemList(item.submenu)}</div>}
      </div>
    )
  }

  renderItemList = items => items.map(this.renderItem)

  render = () => this.renderItemList(this.props.items)
}

export default NavigationMenu
